var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.hasShown)?_c('CoverSheet',{attrs:{"title":_vm.welcomeMessage,"show":_vm.showWelcomeSession,"data-testid":"welcome-curtain"},on:{"on-hide":_vm.handleOnHideWelcomeMessage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }